<div class="page-wrapper pre-auth-page py-5">
  <div class="container-fluid flex-grow-1">
    <div class="actions-container d-flex justify-content-end align-items-end gap-5">
      <button type="buttom"
        class="btn btn-secondary mb-4" (click)="logout()">
        {{ 'COMMON.LOGOUT' | translate }}
      </button>
      <app-language-selector></app-language-selector>
    </div>
    <div class="row position-row g-0">
      <div class="col-12"
        [ngClass]="{'col-lg-4  d-flex flex-column justify-content-center align-items-center': (hasConfirmedReferral$ | async) === false}">
        <router-outlet></router-outlet>
      </div>
      @if ((hasConfirmedReferral$ | async) === false) {
        <div class="col-lg-8 d-none d-lg-block img-wrap">
          <img class="auth-image" [src]="unauthorizedLogicService.unauthorizedScreenImage$ | async">
        </div>
      }
    </div>
  </div>
</div>